import React from 'react';
import PropTypes from 'prop-types';

const ImageJoueur = ({nom, dossierImage}) => {
    return (
        <img
            src={dossierImage
                ? process.env.PUBLIC_URL + `/images/${dossierImage}/${nom}`
                : process.env.PUBLIC_URL + `/images/joueurs/${nom}.jpg`
            }
            alt={`I ${nom}`}
            className="max-w-[80vw] max-h-[80vh] w-auto h-auto rounded-md object-contain"
        />
    )
}

ImageJoueur.propTypes = {
    nom: PropTypes.string.isRequired,
    dossierImage: PropTypes.string,
}

export default ImageJoueur;